import { useState, useEffect } from "react";
import { TbCurrencyTaka } from "react-icons/tb";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { getCartItems, setCartItems } from "utils/cartStorage";
import { assetUrl } from "utils/api";
import {useSettings} from "../context/SettingsContext";
import { t } from "context/translations";

const OrderNowModal = ({ isOpen, onClose, item }) => {
  const [quantity, setQuantity] = useState(1);
  const navigate = useNavigate();
  const { theme, language } = useSettings();
  const isDark = theme === "dark";

  useEffect(() => {
    if (isOpen) setQuantity(1); // reset when opened
  }, [isOpen]);

  if (!isOpen || !item) return null;

  const firstVariant = item.variants?.[0] || {};
  const image = firstVariant.images?.[0]?.thumb;
  const price = firstVariant.flashPrice || 0;
  const title = firstVariant.title || item.mainTitle;
  const selectedDiscount = firstVariant.discount || 0;

  const handleConfirm = () => {
    const existing = getCartItems();

    const index = existing.findIndex((p) => p.item_id === item.item_id);

    if (index !== -1) {
      existing[index].quantity += quantity;
    } else {
      existing.push({
        ...item,
        quantity,
        selectedVariant: firstVariant,
        selectedPrice: price,
        selectedTitle: title,
      });
    }

    setCartItems(existing);
    onClose();
    navigate("/orderDetails");
  };

  return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
        <div className="bg-white rounded-xl w-full max-w-md p-5 relative animate-scaleIn">
          {/* Close */}
          <button
              onClick={onClose}
              className="absolute top-3 right-3 text-red-600 "
          >
            <IoClose size={22} />
          </button>

          {/* Product info */}
          <div className="flex gap-4">
            <img
                src={assetUrl(image)}
                alt={title}
                className="w-24 h-24 rounded-md object-cover border"
            />

            <div className="flex-1 pt-3">
              <h3 className={`font-semibold text-sm ${isDark?"text-white":"text-gray-800"} line-clamp-2`}>
                {title}
              </h3>

              <div className="flex pt-1">
                <div className="flex text-backgroundColor items-center">
                  <p className="font-bold text-blue-800">{price}</p>
                  <TbCurrencyTaka className="font-semibold text-blue-800" />
                </div>
                <div className="relative inline-flex items-center text-gray-400 text-sm ml-2">
                <span className="flex items-center">
                  <p>{selectedDiscount}</p>
                  <TbCurrencyTaka className="font-semibold" />
                </span>
                  <div className="absolute left-0 right-0 top-1/2 h-[.5px] bg-gray-400"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Quantity */}
          <div className="flex justify-between gap-2 mt-3">
            <div className="flex items-center justify-center gap-4">
              <button
                  className="w-7 h-7 flex items-center justify-center rounded-lg text-red-600 shadow-sm bg-red-50 transition-all duration-200"
                  disabled={quantity <= 1}
                  onClick={() => setQuantity((q) => q - 1)}
              >
                -
              </button>

              <span className="font-semibold">{quantity}</span>

              <button
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-green-50 text-green-600 shadow-md hover:shadow-lg hover:scale-[1.05] transition-all duration-200"
                  onClick={() => setQuantity((q) => q + 1)}
              >
                +
              </button>
            </div>

            {/* Confirm */}
            <div>
              <button
                  lang="bn"
                  onClick={handleConfirm}
                  className="px-5 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-800 text-white rounded-md py-2 font-semibold"
              >
                🛒 {t("order", language)}
              </button>
            </div>
          </div>
        </div>
      </div>
  );
};

export default OrderNowModal;
